import { FC } from 'react';
import CustomLoading from '../../CustomLoading';

import { useRenumerationModal } from './context/RenumerationModalContext';

import RenumerationModalHeader from './components/RenumerationModalHeader';
import RenumerationModalBody from './components/RenumerationModalBody';
import RenumerationModalFooter from './components/RenumerationModalFooter';

import './RenumerationModal.scss';

const RenumerationModal: FC = () => {
  const { data } = useRenumerationModal();

  return (
    <>
      <RenumerationModalHeader />
      <RenumerationModalBody />
      <RenumerationModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default RenumerationModal;
